import { buildPaginationQuery } from "@/helpers/request-helpers";
import INotification, { INotificationInput } from "@/interfaces/notification.interface";
import { apiT2B } from "@/lib/axios";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class NotificationService {
  private baseUrl = "api/v1/notification";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<INotification>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const response = await apiT2B.get(`${this.baseUrl}?${paginationQuery}`);
    return response.data;
  }

  async filter(
    filter: IFilter<INotification>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<INotification>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const response = await apiT2B.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response.data;
  }

  async create(formData: INotificationInput): Promise<INotification> {
    const response = await apiT2B.post(this.baseUrl, formData);
    return response.data;
  }

  async getById(notificationId: number): Promise<INotification> {
    const response = await apiT2B.get(`${this.baseUrl}/${notificationId}`);
    return response.data;
  }

  async update(formData: INotificationInput, notificationId: number): Promise<void> {
    await apiT2B.put(`${this.baseUrl}/${notificationId}`, formData);
  }

  async delete(notificationId: number): Promise<void> {
    await apiT2B.delete(`${this.baseUrl}/${notificationId}`);
  }

  async markAsRead(notificationId: number): Promise<void> {
    await apiT2B.put(`${this.baseUrl}/read/${notificationId}`);
  }

  async markManyAsRead(formData: { customerId: number }): Promise<void> {
    await apiT2B.put(`${this.baseUrl}/readall`, formData);
  }
}

const notificationService = new NotificationService();
export default notificationService;
